export default "__VITE_ASSET__CaPrqY5f__"